import React, { Component } from "react";
// import { ERROR_FIELD_MAPPINGS } from "../../constants/ErrorFileds";
import Pagination from "./Pagination";
import TextField from "@material-ui/core/TextField";
import AutoComplete1 from "../../Utils/Select";
import moment from "moment";
import PrintSearchExpot from "./PrintSearchExport";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
//import TablePagination from "@material-ui/core/TablePagination";
import { TablePagination } from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
// import formatTimeStamp, { formatFullTimeStamp } from "../../utils/Utils";
import orderBy from "lodash/orderBy";
import { connect } from "react-redux";
import { styles } from "../../assests/styles/DataTableStyle";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  getAgentList,
  loadCampaignNames,
} from "../../Redux/Actions/webAppActions";
// import classNames from "classnames";
// import EnabledButton from "../UI/EnableButton";
const invertDirection = {
  asc: "desc",
  desc: "asc",
};
const Tooltip1 = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 2,
    marginTop: "0px",
    float: "left",
    //maxWidth:1800
    // display:"flex"
  },
}))(Tooltip);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: "#e8e7e7",
    },
    cursor: "pointer",
    borderBottom: "1px solid rgba(0,0,0,0.1)",
    // "&:hover": {
    //   backgroundColor: "#f2f2f2",
    // },
  },
}))(TableRow);

class DataTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: 0,
      search: "",
      colToSort: "",
      sortDir: "desc",
      page: 0,
      rowsPerPage: this.props.rowsPerPage,
      anchorEl: null,
      exportData: "",
      mobileMoreAnchorEl: null,
      radio: "current",
      index: 0,
      flag: this.props.flag,
      mbrSearch: false,
      sortClick: false,
      selectedPage: 0,
      data: this.props.data,
      resetFlag: this.props.resetFlag,
      //   mbridLit: [],
      doubledClicked: false,
      selectAll: "N",
      selectAllPage: [],
    };
  }

  async componentDidMount() {
    // if(this?.props?.dashboard==="BulkUploadMainProspect"){
    //   if (
    //     this.props.prospectagentList?.length <= 1 ||
    //     this.props.prospectagentList === undefined
    //   ) {
    //     await this.props.getAgentList(this.props?.customerId);
    //   }

    //   if (
    //     this.props.campaignNames?.length <= 1 ||
    //     this.props.campaignNames === undefined
    //   ) {
    //     await this.props.loadCampaignNames();
    //   }
    // }
    //const { loginProfile } = this.props;
    // const MBRIDLIT = loginProfile.filter((data) => data.label === "MBRIDLIT");

    const pageNo = Math.floor(this.props.index / this.props.rowsPerPage);

    const selectedRow = this.props.index % this.props.rowsPerPage;
    this.setState({
      page: pageNo,
      selectedRow: selectedRow,
      rowsPerPage: parseInt(this.props.rowsPerPage),
      selectedPage: pageNo,
      data: this.props.data,
      // mbridLit: MBRIDLIT[0],
    });
  }

  async UNSAFE_componentWillReceiveProps(nextProps) {
    //let check = "N"; Sonar.. 
    let check;
    let val =
      nextProps?.data?.length < nextProps?.rowsPerPage
        ? nextProps?.data?.length
        : nextProps?.rowsPerPage;
    nextProps?.data?.filter((x) => x.checked === "Y").length === val
      ? (check = "Y")
      : (check = "N");

    if (this.props.flag === true || this.props.resetFlag === false) {
      await this.setState({
        page: 0,
        selectedRow: 0,
        index: 0,
        selectedPage: 0,
        sortDir: "desc",
        colToSort: "",
        rowsPerPage: nextProps.rowsPerPage,
        data: nextProps.data,
        selectAll: check,
      });
    } else {
      const pageNo = Math.floor(nextProps.index / nextProps.rowsPerPage);
      const selectedRow = nextProps.index % nextProps.rowsPerPage;

      await this.setState({
        page: pageNo,
        selectedRow: selectedRow,
        rowsPerPage: parseInt(nextProps.rowsPerPage),
        selectedPage: pageNo,
        data: nextProps.data,
        selectAll: check,
      });

      if (this.props.selectAllPage) {
        await this.setState({
          selectAllPage: [],
        });
        this.props.unSelectAllPage(false);
      }
    }
    //search bar shows search result while moving to next page
    // await this.setState({
    //   search: "",
    // });
  }

  generate = (data, header) => {
    var { jsPDF } = require("jspdf");
    var pdfsize = "a4";
    require("jspdf-autotable");
    var doc = new jsPDF("l", "mm", pdfsize);

    const index = header.findIndex((d) => {
      return d.title === "Action";
    });
    if (index !== -1) {
      header.splice(index, 1);
    }

    data.map((d) => {
      if (d.hasOwnProperty("letterAvailabilityInDBGet")) {
        d.letterAvailabilityInDBGet = "PDF";
      }

      if (d.hasOwnProperty("letterAvailabilityInDBPdfIcon")) {
        d.letterAvailabilityInDBPdfIcon = "PDF";
      }
      if (d.hasOwnProperty("checkbox")) {
        delete d.checkbox;
      }
      return d;
    });
    doc.autoTable(header, data);

    doc.save(this.props.status ? this.props.status : "Document.pdf");
    this.handleMenuClose();
  };

  exportDataFunc = (data, all) => {
    const exportdata = this.props.data?.slice();
    const searchdata = data?.slice();

    if (all) {
      this.setState({
        exportData: exportdata,
        radio: "all",
      });
    } else {
      if (data?.length <= this.state.rowsPerPage) {
        this.setState({
          exportData: searchdata,
          radio: "current",
        });
      } else {
        this.setState({
          exportData: searchdata.slice(
            this.state.page * this.state.rowsPerPage,
            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
          ),
          radio: "current",
        });
      }
    }
  };

  handleSort = async (colName) => {
    let type =
      this.state.colToSort === colName
        ? invertDirection[this.state.sortDir]
        : "asc";

    await this.setState((prevState) => ({
      colToSort: colName,
      sortClick: true,
      sortDir: type,
      // data:data
    }));

    //   const { page, rowsPerPage } = this.state;
    //   const index = page * this.state.rowsPerPage;
    //  await  this.props.handleSort(index)
    //   const selectedIndex =
    //     page * this.state.rowsPerPage + this.state.selectedRow;
    //   this.setState({
    //     selectedPage: page,
    //     page,
    //   });
    //   await this.props.clicked(
    //     index,
    //     data[index],
    //     this.state.rowsPerPage
    //   );
  };

  rowSelect = async (e, rowIndex, data) => {
    // e.stopPropagation()
    e.persist();
    const { page, rowsPerPage } = this.state;
    const selectedIndex = page * rowsPerPage + rowIndex;
    await this.setState({
      sortClick: false,
      selectedPage: page,
      selectedRow: rowIndex,
    });
    //SONARlet search = this.state.search;
    if (this.props.pdfFlag) {
      this.props.openPDFDoc(data.leadIdNbr);
    }
    if (this.props.enrollFlag) {
      this.props.DoEnroll(data.leadIdNbr);
    }
    if (this.props.isChecked) {
      this.props.checkBoxHandler(data);
    }
    if (this.props.doubleClick) {
      await this.props.clickedFirst(selectedIndex, data, rowsPerPage);
      if (
        this.props.soapdfclicked ||
        this.props.pdfclicked ||
        this.props.preenrollpdfclicked ||
        this.props.cordinationpdfclicked
      ) {
        await this.props.clicked(selectedIndex, data, rowsPerPage, "ROWSELECT");
      }
      if (e.detail === 2) {
        await this.props.clicked(selectedIndex, data, rowsPerPage, "ROWSELECT");
        this.props.setClick(2);
        e.target.click();
      } else {
        this.props.setClick(0);
      }
    } else {
      await this.props.clicked(selectedIndex, data, rowsPerPage, "ROWSELECT");
      this.props.setClick(0);
      // this.setState({doubledClicked:false,search:search})
    }
    // this.setState({ search: search });
  };

  handleChangePage = async (page) => {
    if (typeof page !== "number") {
      this.fetchMore1(page);
      return;
    }
    //
    const index = page * this.state.rowsPerPage;

    // const selectedIndex =
    //   page * this.state.rowsPerPage + this.state.selectedRow;
    this.setState({
      //  selectedPage: page,
      page,
      selectedRow: 0,
      selectedPage: page,
      currentPage: page,
      selectAll: "N",
    });
    // this.setState({ selectAll: "N" });
    if (!this.props.flag) {
      this.setState({
        mbrSearch: true,
      });
    }
    this.props.handleChangePage && this.props.handleChangePage(index);
    // this.props.clickedFooter &&
    //   this.props.clickedFooter(page, this.props.data[index]);
    // await this.props.clicked(
    //   index,
    //   this.props.data[index],
    //   this.state.rowsPerPage,
    //   "PAGINATION"
    // );
    // await this.props.clicked(
    //   selectedIndex,
    //   this.props.data[selectedIndex],
    //   this.state.rowsPerPage,
    //   "PAGINATION"
    // );
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      page: 0,
      rowsPerPage: event.target.value,
      selectedRow: "",
      index: "",
    });
    this.props.handleChangeRowsPerPage(event.target.value);
  };

  fetchMore1 = async () => {
    await this.props.fetchMore(this.state.page);
  };
  handleMobileMenuOpen = (event) => {
    this.setState({ mobileMoreAnchorEl: event.currentTarget });
  };
  handleMobileMenuClose = () => {
    this.setState({ mobileMoreAnchorEl: null });
  };
  handleMenuClose = () => {
    this.setState({ anchorEl: null });
    this.handleMobileMenuClose();
  };
  serachHandle = (event) => {
    const updatedData = this.props.data.map((item) => ({
      ...item,
      checked: "N",
    }));
    this.props.handleCheck && this.props.handleCheck(updatedData);
    return this.setState({
      page: 0,
      search: event.target.value,
      selectAll: "N",
      data: updatedData,
    });
  };

  labelDisplayedRows = (from, to, count) => {
    const rowsPerPage = this.state.rowsPerPage;
    //SONAR  let currentPage=Math.ceil(from / rowsPerPage) !== 0
    // ? Math.ceil(from / rowsPerPage)
    // : 1;
    // this.setState({ selectAll: "N" });
    return (
      <span>
        Page :
        {Math.ceil(from / rowsPerPage) !== 0
          ? Math.ceil(from / rowsPerPage)
          : 1}{" "}
        - {}
        {count !== -1
          ? Math.ceil(count / rowsPerPage)
          : Math.ceil(to / rowsPerPage)}
      </span>
    );
  };
  handleCheckBox = (name, j) => (event) => {
    event.preventDefault();

    let val = event.target.value;
    this.setState({ selectAll: "N" });

    const index = this.props.currentPage * this.state.rowsPerPage + j;
    this.props.handleCheckBox(name, val, index, this.state.selectAll);
    this.props.saveData(this.state.data);
  };
  handleCheckBoxU = async (data, event) => {
    event.preventDefault();
    let val = event.target.value === "Y" ? "N" : "Y";
    this.state.selectAllPage[this.state.page] = val;
    this.setState({
      selectAll: this.state.page,
      selectAllPage: this.state.selectAllPage,
    });
    this.props.SelectAllHandleCheckBox(
      this.state.rowsPerPage,
      this.state.selectAll,
      val,
      this.state.page,
      this.state.selectedRow,
      data
    );
    this.props.saveData(this.state.data, this.state.page);
    setTimeout(() => {
      this.setState({
        //  selectedPage: page,
        page: this.props.isPage,
        selectedRow: 0,
        selectedPage: this.props.isPage,
        currentPage: this.props.isPage,
      });
    }, 0);
  };
  render() {
    sessionStorage.setItem("backIconButtonProps", this.props.nextPage);
    const { mobileMoreAnchorEl } = this.state;
    const {
      classes,
      searchable,
      sortable,
      exportAsExcel,
      // prospect,
      // removePagination,
      selectedRow,
      notClickable,
      rowsPerPageOptions,
      dateColumn,
      isCheckBoxNeeded,
      identifier,
      isRowDeleteNeeded,
    } = this.props;
    const {
      rowsPerPage,
      page,
      exportData,
      sortClick,
      selectedPage,
      colToSort,
      sortDir,
    } = this.state;
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    let data = this.state.data;
    if (colToSort && this.props.subtab) {
      const name = colToSort;
      if (dateColumn && dateColumn.includes(colToSort)) {
        let tempData = [...this.state.data];
        tempData.sort(function compare(a, b) {
          let date1 =
            a[name].length === 7
              ? [a[name].slice(0, 3), "01/", a[name].slice(3)].join("")
              : a[name];
          let date2 =
            b[name].length === 7
              ? [b[name].slice(0, 3), "01/", b[name].slice(3)].join("")
              : b[name];

          const result =
            date1 === "99/99/9999"
              ? 1
              : date2 === "99/99/9999"
              ? -1
              : Date.parse(date1) - Date.parse(date2);
          return result;
        });
        data = tempData;
        if (sortDir === "desc") {
          data.reverse();
        }
      } else {
        data.sort(function compare(a, b) {
          const result =
            sortDir === "asc"
              ? a[name] > b[name]
                ? -1
                : 1
              : b[name] > a[name]
              ? -1
              : 1;
          return result;
        });
      }
    }

    if (colToSort && !this.props.subtab) {
      const name = colToSort;
      //SONAR let tempData = [...data];
      if (dateColumn && dateColumn.includes(colToSort)) {
        data.sort(function compare(a, b) {
          let date1 =
            a[name].length === 7
              ? [a[name].slice(0, 3), "01/", a[name].slice(3)].join("")
              : a[name];
          let date2 =
            b[name].length === 7
              ? [b[name].slice(0, 3), "01/", b[name].slice(3)].join("")
              : b[name];

          const result =
            date1 === "99/99/9999"
              ? 1
              : date2 === "99/99/9999"
              ? -1
              : Date.parse(date1) > Date.parse(date2)
              ? 1
              : -1;

          return result;
        });
        if (sortDir === "desc") {
          data.reverse();
        }
      } else {
        // tempData = orderBy(data, colToSort, sortDir);
        data.sort(function compare(a, b) {
          if (!isNaN(a[name])) {
            const result =
              sortDir === "asc" ? a[name] - b[name] : b[name] - a[name];
            return result;
          } else {
            const result =
              sortDir === "asc"
                ? a[name]?.toUpperCase() > b[name]?.toUpperCase()
                  ? -1
                  : 1
                : b[name]?.toUpperCase() > a[name]?.toUpperCase()
                ? -1
                : 1;
            return result;
          }
        });
      }
      // data = [...tempData];
    }
    let isdataExist = data?.length > 0;
    const header = this.props.header;
    const search = this.state.search.toLowerCase();
    let msg = "NO DATA FOUND";

    if (this.props.msgChange) {
      msg = this.props.msgChange;
    }

    let resolveFlag =
      this.props.searchFlag === true
        ? this.props.currentUser === this.props.assignee
          ? true
          : false
        : this.props.currentUser === this.props.assignee
        ? false
        : true;

    if (this.state.search) {
      data = data.filter((row) => {
        let flag = false;
        header.forEach((object) => {
          if (row[object.key]) {
            const value = row[object.key].toString().toLowerCase();
            //.slice(0, search.length);
            if (value.includes(search.toLowerCase())) {
              flag = true;
            }
          }
        });
        return flag;
      });
    }
    let footerColSpan = header.length;
    [isCheckBoxNeeded, isRowDeleteNeeded].forEach((q) => {
      if (q) {
        footerColSpan = footerColSpan + 1;
      }
    });
    return (
      <>
        <div>
          {isdataExist && exportAsExcel ? (
            <PrintSearchExpot
              status={this.props.status}
              search={this.state.search}
              searchable={searchable}
              serachHandle={this.serachHandle}
              printTb={this.props.printTb}
              printHandle={this.props.printFun}
              exportAsExcel={exportAsExcel}
              exportHandle={(e) => {
                this.exportDataFunc(data, false);
                this.handleMobileMenuOpen(e);
              }}
              data={data}
              mobileMoreAnchorEl={mobileMoreAnchorEl}
              openMenu={isMobileMenuOpen}
              onCloseMenu={this.handleMenuClose}
              radio={this.state.radio}
              exportDataFunc={this.exportDataFunc}
              exportData={exportData}
              generate={this.generate}
              header={header}
              applExportbtn={this.props.applExportbtn}
            />
          ) : null}
          <div
            className={
              this.props.dashboard === "search"
                ? classes.tableWrapper
                : classes.tableWrapper1
            }
            style={{
              width: this.props.width ? this.props.width : "94%",
              overflowX: "auto",
            }}
          >
            <Table
              className={classes.table}
              // className={removePagination ? classes.tableModified : classes.table}
              id="maintable"
            >
              <TableHead
                className={
                  classes.theaddashboard

                  //: classes.thead
                }
              >
                <StyledTableRow
                  className={classes.headRow}
                  style={{ verticalAlign: "text-top" }}
                >
                  {isCheckBoxNeeded && (
                    <TableCell align="center" className={classes.tableCell}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={
                              this.state.selectAllPage[this.state.page] === "Y"
                                ? "Y"
                                : "N"
                            }
                            color="primary"
                            checked={
                              this.state.selectAllPage[this.state.page] === "Y"
                                ? true
                                : false
                            }
                            classes={{
                              root: classes.checkboxControl,
                            }}
                            onClick={(e) => this.handleCheckBoxU(data, e)}
                          />
                        }
                        classes={{
                          root: classes.checkboxLabel,
                        }}
                      />
                    </TableCell>
                  )}
                  {header.map((mbrCol, i) => (
                    <TableCell
                      align="left"
                      key={i}
                      style={{
                        padding: this?.props?.headerPadding
                          ? this?.props?.headerPadding
                          : "",
                        paddingBottom: "0.4em!important",
                        paddingTop: "0.4em!important",
                        fontWeight: this.props.padding
                          ? "600 !important"
                          : "800 !important",
                        // paddingLeft:"30px",
                        paddingRight: this.props?.paddingRight
                          ? this.props?.paddingRight
                          : "30px",
                        borderTopLeftRadius: i === 0 ? "5px" : "",
                        borderTopRightRadius:
                          i === header.length - 1 ? "5px" : "",
                        color: "#fff",
                        //: "",
                        //fontSize: this.props.fontSize ? this.props.fontSize:""
                      }}
                      className={classes.tableCell}
                    >
                      {mbrCol.key != "DOWNLOADSOA" &&
                      mbrCol.key != "DOWNLOAD" &&
                      mbrCol.key != "SOA" &&
                      mbrCol.key != "PREENROLLMENTFORM" &&
                      mbrCol.key != "COORDINATIONOFCARE" &&
                      mbrCol.key != "Enroll" &&
                      sortable &&
                      isdataExist &&
                      mbrCol.key != "Select" ? (
                        <div
                          onClick={() => this.handleSort(mbrCol.key)}
                          style={{
                            width: this.props.padding
                              ? "min-content !important"
                              : "max-content !important",
                            //width:"min-content",
                            display: "flex",
                            verticalAlign: "top",
                          }}
                        >
                          {mbrCol.label}

                          {this.state.colToSort === mbrCol.key ? (
                            this.state.sortDir === "asc" ? (
                              <span class="sort"> &nbsp;&#8593;</span>
                            ) : (
                              <span class="sort"> &nbsp;&#8595;</span>
                            )
                          ) : (
                            <span class="sort sort-default">
                              {" "}
                              &nbsp;&#8597;
                            </span>
                          )}
                        </div>
                      ) : (
                        <div onClick={this.props.handleAll}>{mbrCol.label}</div>
                      )}
                    </TableCell>
                  ))}
                  {isRowDeleteNeeded && (
                    <TableCell align="center" className={classes.tableCell}>
                      {"      "}
                    </TableCell>
                  )}
                  {/* {this.props.activityTable && this.props.flagUnassigned!=="UNASSIGNED" ? (
                  resolveFlag || this.props.supervisor==="A" ? (
                    <TableCell align="left"
                    className={classes.headerCell}
                   
                    style={{
                      paddingBottom: "0.4em!important",
                      paddingTop: "0.4em!important",
                    }}>
                      <EnabledButton
                        variant="outlined"
                        color="primary"
                        onClick={this.props.updatedVal}
                      >
                        Resolve
                      </EnabledButton>
                    </TableCell>
                  ) : null
                ) : null} */}
                </StyledTableRow>
              </TableHead>

              <TableBody>
                {data?.length < 1 && (
                  <StyledTableRow>
                    <TableCell
                      name="cell"
                      style={{
                        paddingBottom: "0.4em!important",
                        paddingTop: "0.4em!important",
                        padding: this.props.padding ? this.props.padding : "",
                      }}
                      colSpan={header.length}
                      className={classes.tableCell}
                    >
                      {msg}
                    </TableCell>
                  </StyledTableRow>
                )}

                {(this.props?.dashboard === "BulkUploadMain" ||
                  this.props?.dashboard === "BulkUploadMainProspect") &&
                  data
                    ?.slice(
                      page * parseInt(rowsPerPage),
                      page * parseInt(rowsPerPage) + parseInt(rowsPerPage)
                    )
                    .map((genericDetail, j) => (
                      <StyledTableRow
                        style={{ backgroundColor: "#fff", fontSize: ".85em" }}
                        className={
                          selectedRow
                            ? classes.row
                            : this.state.selectedRow === j &&
                              !sortClick &&
                              page === selectedPage &&
                              !notClickable
                            ? classes.selectedrow
                            : classes.row
                        }
                        key={j}
                        onClick={
                          notClickable
                            ? () => {}
                            : (e) =>
                                this.rowSelect(
                                  e,
                                  j,
                                  data[page * rowsPerPage + j]
                                )
                        }
                      >
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          <a>{genericDetail.uploadFileName}</a>
                        </TableCell>
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          {genericDetail.uploadDate}
                        </TableCell>
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          {genericDetail.uploadedBy}
                        </TableCell>
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          {genericDetail.uploadStatus}
                        </TableCell>
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          {genericDetail.totalCount}
                        </TableCell>
                        <TableCell style={{ padding: "8px 12px 9px 47px" }}>
                          {genericDetail.successCount}
                        </TableCell>
                        {genericDetail?.rejectionCount != "0" ? (
                          <Tooltip1
                            title="Click here to see the Rejected"
                            aria-label="Click here to see the Rejected"
                          >
                            <TableCell
                              class="anchrhiglighted"
                              style={{ padding: "8px 12px 9px 47px" }}
                              data-toggle="modal"
                              data-target={this.props?.modalSelect}
                              onClick={(e) =>
                                this.props?.columnSelected(
                                  genericDetail.uploadFileName,
                                  genericDetail.uploadFileId,
                                  "Rejected"
                                )
                              }
                            >
                              {genericDetail.rejectionCount}
                            </TableCell>
                          </Tooltip1>
                        ) : (
                          <TableCell
                            style={{ padding: "8px 12px 9px 47px" }}
                            class="color-black"
                          >
                            {genericDetail.rejectionCount}
                          </TableCell>
                        )}
                        {genericDetail?.errorCount != "0" ? (
                          <Tooltip1
                            title="Click here to see the Errored"
                            aria-label="Click here to see the Errored"
                          >
                            <TableCell
                              class="anchrhiglighted"
                              data-toggle="modal"
                              style={{ padding: "8px 12px 9px 47px" }}
                              data-target={this.props?.modalSelect}
                              onClick={(e) =>
                                this.props?.columnSelected(
                                  genericDetail.uploadFileName,
                                  genericDetail.uploadFileId,
                                  "Errored"
                                )
                              }
                            >
                              {genericDetail.errorCount}
                            </TableCell>
                          </Tooltip1>
                        ) : (
                          <TableCell
                            class="color-black"
                            style={{ padding: "8px 12px 9px 47px" }}
                          >
                            {genericDetail.errorCount}
                          </TableCell>
                        )}
                      </StyledTableRow>
                    ))}

                {this.props?.dashboard != "BulkUploadMain" &&
                  this.props?.dashboard != "BulkUploadMainProspect" &&
                  data
                    ?.slice(
                      page * parseInt(rowsPerPage),
                      page * parseInt(rowsPerPage) + parseInt(rowsPerPage)
                    )
                    .map((genericDetail, j) => (
                      <StyledTableRow
                        style={{ backgroundColor: "#fff", fontSize: ".85em" }}
                        className={
                          selectedRow
                            ? classes.row
                            : this.state.selectedRow === j &&
                              !sortClick &&
                              page === selectedPage &&
                              !notClickable
                            ? classes.selectedrow
                            : classes.row
                        }
                        key={j}
                        onClick={
                          notClickable
                            ? () => {}
                            : (e) =>
                                this.rowSelect(
                                  e,
                                  j,
                                  data[page * rowsPerPage + j]
                                )
                        }
                      >
                        {isCheckBoxNeeded && (
                          <TableCell
                            align="center"
                            className={classes.tableCell}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name={
                                    genericDetail.leadIdNbr ||
                                    genericDetail?.firstName
                                  }
                                  value={
                                    genericDetail.checked === "Y" ? "Y" : "N"
                                  }
                                  color="primary"
                                  checked={
                                    genericDetail.checked === "Y" ? true : false
                                  }
                                  classes={{
                                    root: classes.checkboxControl,
                                  }}
                                  onClick={this.handleCheckBox(
                                    genericDetail.leadIdNbr ||
                                      genericDetail?.firstName,
                                    j
                                  )}
                                />
                              }
                              classes={{
                                root: classes.checkboxLabel,
                              }}
                            />
                          </TableCell>
                        )}
                        {header.map((genericKey, p) =>
                          genericKey.key === "transReplyCd" ? (
                            <Tooltip1
                              title={genericDetail.transReplyDefinition}
                              placement="centre top"
                            >
                              <TableCell
                                key={p}
                                style={{
                                  // this.props.errorTable ? { color: "red" } : null
                                  color: this.props.errorTable ? "red" : null,
                                  padding: this.props.padding
                                    ? this.props.padding
                                    : "",
                                }}
                                align="center"
                                // className={
                                //   genericKey.key === "appliedAmt"
                                //     ? classes.appliedAmtTableCell
                                //     : classes.tableCell
                                // }

                                className={classes.tableCell}
                              >
                                {" "}
                                {genericDetail[genericKey.key]}
                                {/* <i   className={classNames("fas fa-info-circle",classes.infoIcon)}></i> */}
                              </TableCell>
                            </Tooltip1>
                          ) : genericKey.key === "relation" &&
                            identifier === "callsTable" ? (
                            <TableCell
                              key={p}
                              style={{
                                // this.props.errorTable ? { color: "red" } : null
                                color: this.props.errorTable ? "red" : null,
                                padding: this.props.padding
                                  ? this.props.padding
                                  : "",
                              }}
                              align="center"
                              // className={
                              //   genericKey.key === "appliedAmt"
                              //     ? classes.appliedAmtTableCell
                              //     : classes.tableCell
                              // }

                              className={classes.tableCell}
                            >
                              {"  "}
                              {this.props?.authorizedrelations?.filter(
                                (data1) =>
                                  data1.value === genericDetail[genericKey.key]
                              ).length !== 0 &&
                                this.props?.authorizedrelations?.filter(
                                  (data1) =>
                                    data1.value ===
                                    genericDetail[genericKey.key]
                                )[0].label}
                              {/* <i   className={classNames("fas fa-info-circle",classes.infoIcon)}></i> */}
                            </TableCell>
                          ) : (
                            <TableCell
                              key={p}
                              data-toggle="modal"
                              data-target={
                                genericKey.label != "SOA"
                                  ? this.props?.modalSelect
                                  : ""
                              }
                              // style={
                              //   this.props.errorTable ? { color: "red" } : null
                              // }
                              style={{
                                // this.props.errorTable ? { color: "red" } : null
                                color: this.props.errorTable ? "red" : null,
                                padding: this.props.padding
                                  ? this.props.padding
                                  : "",
                              }}
                              align="left"
                              className={classes.tableCell}
                              // onClick={
                              //   this.props.cellClick?this.props.cellHanlder(genericDetail,genericKey.label):()=>{}
                              // }
                            >
                              {/* {this.props.errorTable && genericKey.key === "fieldNbr"
                          ? ERROR_FIELD_MAPPINGS[
                            genericDetail[genericKey.key]
                          ] === "M360 ID" &&
                            this.state.mbridLit.value === "TSA"
                            ? "WIPRO ID"
                            : ERROR_FIELD_MAPPINGS[
                            genericDetail[genericKey.key]
                            ]
                          : genericKey.key
                            .substr(genericKey.key.length - 4)
                            .toLowerCase() === "time"
                            ? genericKey.title === "Date/Time"
                              ? formatFullTimeStamp(genericDetail[genericKey.key])
                              : formatTimeStamp(genericDetail[genericKey.key])
                            : genericDetail[genericKey.key]} */}
                              {genericDetail[genericKey.key]}
                            </TableCell>
                          )
                        )}
                        {isRowDeleteNeeded && (
                          <TableCell>
                            <i
                              className="fa fa-times"
                              aria-hidden="true"
                              style={{ fontSize: "1.5rem" }}
                              title="Delete"
                              onClick={() =>
                                this.props.deleteRow(genericDetail.leadIdNbr)
                              }
                            />
                          </TableCell>
                        )}
                        {this.props.activityTable ? (
                          resolveFlag ? (
                            <TableCell
                              style={{
                                padding: this.props.padding
                                  ? this.props.padding
                                  : "",
                              }}
                            ></TableCell>
                          ) : null
                        ) : null}
                      </StyledTableRow>
                    ))}
              </TableBody>
              {/* {!removePagination && data?.length > 0 ? ( */}
              <TableFooter>
                <StyledTableRow>
                  <TablePagination
                    className={classes.pagination}
                    rowsPerPageOptions={
                      rowsPerPageOptions ? rowsPerPageOptions : []
                    }
                    colSpan={footerColSpan}
                    count={data?.length}
                    rowsPerPage={rowsPerPage}
                    //used to pass Total count -DB
                    backIconButtonProps={this.props.nextPage}
                    page={this.state.page}
                    SelectProps={{
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    }}
                    labelRowsPerPage={
                      <>
                        <span>
                          Total Record: <strong>{data?.length}</strong>
                        </span>
                        <span>Rows per page</span>
                      </>
                    }
                    classes={{
                      toolbar: classes.footer,
                    }}
                    labelDisplayedRows={({ from, to, count }) =>
                      this.labelDisplayedRows(from, to, count)
                    }
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    ActionsComponent={Pagination}
                    nextIconButtonProps={this.fetchMore1}
                  />
                </StyledTableRow>
              </TableFooter>
              {/* ) : null} */}
            </Table>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    // loginProfile: state.loginData.profiles,
    currentPage: state.export.currentPage,
    prospectagentList: state.campaignProspect.agentList,
    campaignNames: state.campaignProspect.campaignNamesList,
    customerId: state.login.customerId,
  };
};
const mapDispatchToProps = {
  getAgentList,
  loadCampaignNames,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(DataTable));
// export default DataTable;
